import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from './useLocalStorage';
import axios from 'axios';

const API_URL = import.meta.env.VITE_APP_API_URL;
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [rol, setRol] = useLocalStorage("rol", null);
    const [rolNombre, setRolNombre] = useLocalStorage("rolNombre", null);
    const [token, setToken] = useLocalStorage("token", null);
    const [nombre, setNombre] = useLocalStorage("nombre", null);
    const [cargo, setCargo] = useLocalStorage("cargo", null);
    const [sedeActual, setSedeActual] = useLocalStorage("sedeActual", null);
    const [programa, setPrograma] = useLocalStorage("programa", null);
    const [sideMenuOpen, setSideMenuOpen] = useLocalStorage("sideMenuOpen", true);
    const configurarSede = async (sede) => {
        setSedeActual(sede);
    }
    const ingresar = React.useCallback(async (usr_login, usr_password) => {
        const response = await axios.post(`${API_URL}/users/login`, { usr_login, usr_password});
        if (response.data.token) {
            setUser(response.data.user.id);
            setRol(response.data.user.usrRolid);
            setRolNombre(response.data.user.rolNombre);
            setNombre(response.data.user.usrNombre);
            setCargo(response.data.user.usrCargo);
            setToken(response.data.token.token);
            setPrograma(response.data.user.programa);
            setSideMenuOpen(true);
        }
        return response.data;
    }, [setSedeActual, setUser, setRol, setRolNombre, setNombre, setCargo, setToken, setSideMenuOpen, setPrograma]);
    const fetchPermisosPaginas = React.useCallback(async () => {
        if (!token) return;
        const response = await axios.get(`${API_URL}/parametros/ppaginas`, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    }, [token]);
    const OpenSideMenu = React.useCallback(({ value }) => {
        setSideMenuOpen(value);
    }, [setSideMenuOpen]);
    const logout = React.useCallback(async () => {
        if (token) {
            await axios.post(`${API_URL}/users/logoutUser`, { idUser: user }, { headers: { Authorization: `Bearer ${token}` } });
        }
        setSedeActual(null);
        setUser(null);
        setRol(null);
        setRolNombre(null);
        setNombre(null);
        setCargo(null);
        setToken(null);
        setPrograma(null);
        setSideMenuOpen(false);
    }, [token, user, setSedeActual, setUser, setRol, setRolNombre, setNombre, setCargo, setToken, setPrograma]);

    const contextValue = useMemo(() => ({
        user, rol, rolNombre, token, nombre, cargo, sedeActual, sideMenuOpen, programa,
        ingresar, logout, OpenSideMenu, fetchPermisosPaginas, configurarSede
    }), [
        user, rol, rolNombre, token, nombre, cargo, sedeActual, sideMenuOpen, programa,
        ingresar, logout, OpenSideMenu, fetchPermisosPaginas, configurarSede
    ]);

    return (
        <AuthContext.Provider value={contextValue}>
        {children}
        </AuthContext.Provider>
    );
};


const useAuth = () => {
const context = React.useContext(AuthContext);

if (context === undefined) {
    throw new Error("useAuth must be used within a AuthProvider");
}

return context;
};
AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { AuthProvider, useAuth };